import { isRequiredField } from '@/lib/formik-utils'
import { logger } from '@/lib/logger'
import { WithProps } from '@/types/core-types'
import valid from 'card-validator'
import { Field, FieldHookConfig, FieldValidator, useField, useFormikContext } from 'formik'
import React, { useEffect, useState } from 'react'

type TextInputFieldProps = { label?: string; showError?: boolean; placeholder?: string } & FieldHookConfig<any>
//JSX.IntrinsicElements["input"]
const TextInputField: React.FC<TextInputFieldProps> = ({
  className,
  label,
  required,
  placeholder,
  disabled,
  showError = true,
  ...props
}) => {
  const [field, meta] = useField(props.name)
  const { error } = meta || {}
  const hasError = meta.touched && meta.error ? true : false
  return (
    <div className={className}>
      <label htmlFor={field.name} className={`block text-sm font-medium  text-gray-700`}>
        {label}
        {required && <span className="ml-1 text-red-500">*</span>}
      </label>
      <div className="mt-1">
        <input
          {...field}
          placeholder={placeholder}
          className={`block w-full rounded-md !border-l-[3px] border-gray-300 bg-[length:9px] bg-no-repeat shadow-sm transition-[border-color] duration-500 ease-out focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm ${
            hasError ? 'border-red-500' : ''
          }`}
          disabled={disabled}
        />
        {showError && hasError && <p className="mt-2 text-sm text-red-500">{error}</p>}
      </div>
    </div>
  )
}

export default TextInputField
